module.exports = __webpack_public_path__ + "static/media/si.a6c3b953.svg";